<div class="navigation-block w-100">
	@if (headerKey) {
		<div [class.p-1]="globalSearchView" class="navigation-block-header pb-0">
			<div class="d-flex justify-content-between">
				<div>
					{{ headerKey | translate }}
				</div>
				<div class="d-flex justify-content-between">
					<app-reset-filter [active]="hasSomeChecked" (resetFilter)="resetFilter.emit()"></app-reset-filter>
					<app-collapse-filter (collapse)="collapse($event)"></app-collapse-filter>
				</div>
			</div>
		</div>
	}
	@if (emptySearchResults || (!hideHeader && sortedTags?.length)) {
		<div>
			@if (sortedTags?.length) {
				<div [class.ps-1]="headerKey" [ngClass]="collapsed ? 'filter-collapsed' : 'pb-2'" class="navigation-block-body">
					@for (tag of sortedTags; track tag) {
						<button
							type="button"
							(click)="onTagClicked(tag)"
							class="btn btn-outline-primary btn-sm ade-tag-rounded mt-2 me-2"
							data-toggle="button"
							[attr.aria-pressed]="isTagSelected(tag)"
							[ngClass]="{ active: isTagSelected(tag), 'tag-bg': !isTagSelected(tag) }"
							[disabled]="!clickable">
							{{ tag.displaystring | translate }}
							@if (tag.id === sustainabilityTagId
									|| tag.id === dgnbTagId) {
								<img
									src="/assets/sustainability/dgnb/nachhaltigkeit.svg"
									alt="Nachhaltigkeitslogo"
									class="sustainability"
									loading="lazy" />
							}
						</button>
					}
				</div>
			}
			<!-- <div *ngIf="emptySearchResults" class="fst-italic text-smaller">
      {{ 'attachments.emptyAdditionalInfos'| translate }}
    </div>
    <div class="pb-4"></div> -->
		</div>
	}
	@if ((emptySearchResults && hideHeader) || !sortedTags?.length) {
		<div [ngClass]="collapsed ? 'filter-collapsed' : 'mt-2'">
			<span class="text-muted"
				><i>{{ 'global.filter-not-available' | translate }}</i></span
			>
		</div>
	}
</div>
@if (hideHeader && sortedTags?.length) {
	<div class="w-100">
		@for (tag of sortedTags; track tag) {
			<button
				type="button"
				(click)="onTagClicked(tag)"
				class="btn btn-outline-primary btn-sm ade-tag-rounded mb-2 me-2"
				data-toggle="button"
				[attr.aria-pressed]="isTagSelected(tag)"
				[ngClass]="{ active: isTagSelected(tag), 'tag-bg': !isTagSelected(tag) }"
				[disabled]="!clickable">
				{{ tag.displaystring | translate }}
			</button>
		}
	</div>
}
